import { utl_pageId } from "../base/_utils";

/* ========= ANIMATE INTERIOR PAGE SUB-HEADINGS ========= */
export default function animateSubHeadingInit() {
    const runAnimateSubHeading = () => {
        const subHeadings = document.querySelectorAll(".sub-heading");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animated-border");
                    } else {
                        entry.target.classList.remove("animated-border");
                    }
                });
            },
            {
                threshold: 1, // Trigger when 10% of the element is visible
                rootMargin: "0px 0px -45% 0px", // Wait until user scrolls in a bit more
            }
        );

        subHeadings.forEach((heading) => observer.observe(heading));
    };

    /* ==== Only run code if on any page other than these === */
    if (utl_pageId() !== "main-index" && utl_pageId() !== "events" && utl_pageId() !== "contact") {
        runAnimateSubHeading();
    }
}
